import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { BuisnessLayout } from "Views/Business_ops/Business_ops_utils/BuisnessLayout";
import BuisnessOpsDashboard from "Views/Business_ops/Docs/BuisnessOpsDashboard";
import BuisnessOpsReview from "Views/Business_ops/Docs/BuisnessOpsReview";
import JobBuisnessReview from "Views/Business_ops/Docs/JobBuisnessReview";
import Error from "Views/Common/Docs/error";
import { InitializeProjectSetup } from "Views/Common/Docs/InitializeProjectSetup";
import Login from "Views/Common/Docs/Login";
import "react-quill/dist/quill.snow.css";
import CustomizeFieldLabels from "Views/Hiring_manager/Docs/CustomisedColoum";
import CustomisedColoum from "Views/Hiring_manager/Docs/CustomisedColoum";
import { Home } from "Views/Hiring_manager/Docs/Home";
import InterviewBandwidth from "Views/Hiring_manager/Docs/InterviewBandwith";
import InterviewBandwith from "Views/Hiring_manager/Docs/InterviewBandwith";
import InterviewBandwidthDashboard from "Views/Hiring_manager/Docs/InterviewBandwithDashboard";
import InterviewDesignDashboard from "Views/Hiring_manager/Docs/InterviewDesignDashboard";
import InterviewDesignScreen from "Views/Hiring_manager/Docs/InterviewDesignScreen";
import JobRequisition from "Views/Hiring_manager/Docs/JobRequisition";
import PlanningForm from "Views/Hiring_manager/Docs/PlanningForm";
import PlanninggForm from "Views/Hiring_manager/Docs/PlanningFormm";
import { PlanningScreen } from "Views/Hiring_manager/Docs/PlanningScreen";
import ResponsibilitySetting from "Views/Hiring_manager/Docs/resposbility";
import SetApproveScreen from "Views/Hiring_manager/Docs/SetApproveScreen";
import UploadScreen from "Views/Hiring_manager/Docs/UploadScreen";
import { Layout } from "Views/Hiring_manager/Hiring_manager_utils/Layout";
import InterviewerDashboard from "Views/Interviewer/Docs/InterviewerDashboard";
import LaunchInterview from "Views/Interviewer/Docs/interviewLaunchScreen";
import { InterviwerLayout } from "Views/Interviewer/Interviewer_utils/InterviwerLayout";
import ApprovalScreen from "Views/Recruiter/Docs/ApprovalScreen";
import CandidateScreen from "Views/Recruiter/Docs/CandidateScreen";
import HiringManagerApproval from "Views/Recruiter/Docs/HiringManagerApproval";
import InterviewerStages from "Views/Recruiter/Docs/InterviewerStages";
import RecruiterNegotiation from "Views/Recruiter/Docs/RecruiterNegotiation";
import OfferBGV from "Views/Recruiter/Docs/OfferBGV";
import RecruiterScreening from "Views/Recruiter/Docs/RecruiterScreening";
import RecruiterScreeningDashboard from "Views/Recruiter/Docs/RecruiterScreeningDashboard";
import { RecruiterDashboard } from "Views/Recruiter/Docs/RecuirmentDashboard";
import ScheduleInteview from "Views/Recruiter/Docs/ScheduleInteview";
import ScoreCard from "Views/Recruiter/Docs/ScoreCard";
import { RecruiterLayout } from "Views/Recruiter/Recruiter_utils/layout";
import PersonalDetailsForm from "Views/Recruiter/Docs/PersonalDetailsform";
import Configure_bg_packages from "Views/Hiring_manager/Docs/Configure_bg_packages";
import InitiateBG from "Views/Recruiter/Docs/InitiateBGDashboard";
import { VendorLayout } from "Views/Vendor/Recruiter_utils/layout";
import { VendorDashboard } from "Views/Vendor/Docs/VendorDashboard";
import PreOnboardingForm from "Views/Recruiter/Docs/PreOnboardingForm";
import PreOnboarding from "Views/Recruiter/Docs/PreOnboarding";
import SilvermedelistReport from "Views/Hiring_manager/Docs/SilvermedelistReport";
import CompensationDetailsReport from "Views/Hiring_manager/Docs/CompensationDetailsReport";
import DeclinedReport from "Views/Hiring_manager/Docs/DeclinedReport";
import FutureStartDataReport from "Views/Hiring_manager/Docs/FutureStartDataReport";
import RecruiterScreeningEdit from "Views/Recruiter/Docs/RecruiterScreeningEdit";

function App() {
  return (
    <React.Fragment>
      <ToastContainer theme="light" />

      <Routes>
        <Route element={<InitializeProjectSetup />}>
          <Route index element={<Login />} />

          <Route path="/hiring_manager">
            <Route element={<Layout />}>
              <Route path="dashboard" element={<Home />} />
              {/* <Route path="hiring_manager_dashboard" element={<Home />} /> */}
              <Route path="planning">
                <Route index element={<PlanningScreen />} />
                {/* <Route path="hiring_planning_form" element={<PlanningForm />} /> */}
                <Route
                  path="hiring_planning_form"
                  element={<PlanninggForm />}
                />
                <Route
                  path="interview_design_screen"
                  element={<InterviewDesignScreen />}
                />
                <Route path="bg_packages" element={<Configure_bg_packages />} />
                <Route
                  path="interview_design_dashboard"
                  element={<InterviewDesignDashboard />}
                />
                <Route
                  path="interviewer_bandwidth"
                  element={<InterviewBandwidth />}
                />
                <Route
                  path="interviewer_bandwidth_dashboard"
                  element={<InterviewBandwidthDashboard />}
                />
                <Route
                  path="stage_alert_and_responsibility_settings"
                  element={<ResponsibilitySetting />}
                />
                <Route
                  path="customised_column_and_settings"
                  element={<CustomizeFieldLabels />}
                />
                <Route
                  path="set_approve_screen"
                  element={<SetApproveScreen />}
                />
                <Route path="upload_screen" element={<UploadScreen />} />
              </Route>
              <Route path="report">
                 <Route index element={<SilvermedelistReport />} />
                  <Route path="compensation_report" element={<CompensationDetailsReport/>}/>
                  <Route path="declined_report" element={<DeclinedReport/>}/>
                  <Route path="future_start_data_report" element={<FutureStartDataReport/>}/>
              </Route>
              <Route path="create_job_requisition" element={<Home />} />
              <Route path="job_requisition" element={<JobRequisition />} />
            </Route>

          </Route>

          <Route path="/recruiter">
            <Route element={<RecruiterLayout />}>
              <Route path="dashboard" element={<RecruiterDashboard />} />
              <Route path="schedule_interview" element={<ScheduleInteview />} />
              <Route path="candidate" element={<CandidateScreen />} />
              <Route path="initiate_bg" element={<InitiateBG />} />

              <Route
                path="recruiter_screening"
                element={<RecruiterScreening />}
              />
                            <Route
                path="recruiter_screening_edit"
                element={<RecruiterScreeningEdit />}
              />
              <Route
                path="screening_dashboard"
                element={<RecruiterScreeningDashboard />}
              />
              <Route
                path="hiring_manager_approval"
                element={<HiringManagerApproval />}
              />
              <Route path="score_card" element={<ScoreCard />} />
              <Route path="interview_stages" element={<InterviewerStages />} />
              <Route
                path="recruiter_negotiation"
                element={<RecruiterNegotiation />}
              />
              <Route path="final_approval" element={<ApprovalScreen />} />
              <Route path="offer&bgv" element={<OfferBGV />} />
              <Route path="onboarding" element={<PreOnboarding />} />

              
            </Route>
          </Route>

          <Route path="/business_ops">
            <Route element={<BuisnessLayout />}>
              <Route path="dashboard" element={<BuisnessOpsDashboard />} />
              <Route path="buisness_review" element={<JobBuisnessReview />} />
            </Route>
          </Route>

          <Route path="/interviewer">
            <Route element={<InterviwerLayout />}>
              <Route path="dashboard" element={<InterviewerDashboard />} />
              <Route path="launch_interview" element={<LaunchInterview />} />
            </Route>
          </Route>

          <Route path="/vendor">
            <Route element={<VendorLayout />}>
              <Route path="dashboard" element={<VendorDashboard />} />
            </Route>
          </Route>

          <Route path="/candidate">
            <Route path="pre_onboarding_form" element={<PreOnboardingForm />} />

            <Route
                path="personal_details_form"
                element={<PersonalDetailsForm />}
              />
          </Route>


          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
    </React.Fragment>
  );
}

export default App;

